const PROVIDER_OPTIONS = [
  { text: "5STREAM", value: "5STREAM" },
  { text: "LOCAL", value: "LOCAL" },
  { text: "AV Sportradar", value: "AV_SPORTRADAR" },
];

const PROVIDER_FIELD = {
  name: "defaultPlatformProvider",
  size: "col-sm-4 col",
  label: "Default Platform Provider:",
  type: "select",
  placeholder: "defaultPlatformProvider",
  className: "form-control",
  required: true,
  initial: "defaultPlatformProvider",
  options: PROVIDER_OPTIONS,
  errors: {
    required: "Default Platform Provider is required",
  },
};

const ORG_FIELD = {
  name: "organizationId",
  size: "col-sm-4 col",
  label: "Organization ID:",
  type: "text",
  placeholder: "organizationId",
  className: "form-control",
  required: true,
  hidden: true,
  initial: "organizationId",
  errors: {
    required: "Organization ID is required",
  },
};

const COMPETITION_FIELD = {
  name: "competitionId",
  size: "col-sm-4 col",
  label: "Competition ID:",
  type: "text",
  placeholder: "competitionId",
  className: "form-control",
  required: true,
  hidden: true,
  initial: "competitionId",
  errors: {
    required: "Competition ID is required",
  },
};

const SEASON_FIELD = {
  name: "seasonId",
  size: "col-sm-4 col",
  label: "Season ID:",
  type: "text",
  placeholder: "seasonId",
  className: "form-control",
  required: true,
  hidden: true,
  initial: "seasonId",
  errors: {
    required: "Season ID is required",
  },
};

const FIXTURE_FIELD = {
  name: "fixtureId",
  size: "col-sm-4 col",
  label: "Fixture ID:",
  type: "text",
  placeholder: "fixtureId",
  className: "form-control",
  required: true,
  hidden: true,
  initial: "fixtureId",
  errors: {
    required: "Fixture ID is required",
  },
};

const FORM_BASE = {
  title: "Set Default Platform Provider",
  endpoint: "v1/#0/o/#1/video/provider/settings",
  parameters: ["sport", "organizationId"],
  method: "CUSTOM",
  link: {
    show: false,
    message: "",
    path: "",
    parameters: [],
  },
  submit: "Save",
};

const formSetup = {
  forms: {
    SetCompetitionVideoProviderSettings: {
      ...FORM_BASE,
      fields: [PROVIDER_FIELD, ORG_FIELD, COMPETITION_FIELD],
    },
    SetSeasonVideoProviderSettings: {
      ...FORM_BASE,
      fields: [PROVIDER_FIELD, ORG_FIELD, COMPETITION_FIELD, SEASON_FIELD],
    },
    SetFixtureVideoProviderSettings: {
      ...FORM_BASE,
      fields: [PROVIDER_FIELD, ORG_FIELD, FIXTURE_FIELD],
    },
  },
};

export default formSetup;
